import axios from "axios";
import { baseUrl } from "../config/api-config";

export const createItem = (data, token) => axios.post(`${baseUrl}/item`, data, {
    headers: {
        authorization: token
    }
})

export const deleteItem = (id, token) => axios.delete(`${baseUrl}/item/${id}`, {
    headers: {
        authorization: token
    }
})

export const updateItem = (id, data, token) => axios.patch(`${baseUrl}/item/${id}`, data, {
    headers: {
        authorization: token
    }
})

export const getItemById = (id, token) => axios.get(`${baseUrl}/item/${id}`, {
    headers: {
        authorization: token
    }
})
